const RankingColumns = [
  {
    name: "RANK",
    value: "current-rank",
    show: true,
    isBold: true,
  },
  {
    name: "COMPANY/OWNERSHIP",
    value: "name",
    show: true,
    isBold: true,
  },
  {
    name: "TOTAL INCOME \n(INR Cr)",
    value: "revenue",
    subvalue: "revenue-yoy",
    show: true,
  },
  {
    name: "NET OPERATING INCOME \n(INR Cr)",
    value: "noi",
    subvalue: "noi-yoy",
    show: true,
  },
  {
    name: "PROFIT \n(INR Cr)",
    value: "profit",
    subvalue: "profit-yoy",
    show: true,
    sortable: true,
  },
  {
    name: "Profit as % \nof Revenue",
    value: "profit-by-revenue",
    show: true,
  },
  {
    name: "INTEREST COST / AS % OF \nEBITDA",
    value: "interest-cost",
    subvalue: "interest-cost-ebitda",
    show: true,
  },
  {
    name: "cash & bank balance \n(INR Cr)",
    value: "cash-bank-balance",
    show: true,
  },
  {
    name: "total debt \n(INR Cr)",
    value: "total-debt",
    show: true,
  },
  {
    name: "debt-equity \nratio",
    value: "debt-equity-ratio",
    show: true,
  },
  {
    name: "TOTAL ASSETS \n(INR Cr)",
    value: "assets",
    subvalue: "assets-yoy",
    show: true,
    sortable: true,
  },
  {
    name: "NET WORTH \n(INR Cr)",
    value: "networth",
    subvalue: "networth-yoy",
    show: true,
    sortable: true,
  },
  {
    name: "RONW%",
    value: "ronw",
    show: true,
  },
  {
    name: "ROCE%",
    value: "roce",
    show: true,
  },
  {
    name: "EMPLOYEES \n(IN NOS.)",
    value: "employee-count",
    show: true,
    sortable: true,
  },
  {
    name: "T12M AVG \nM-CAP \n(INR Cr)",
    value: "t12m-avg-m-cap",
    show: true,
  },
  {
    name: "TSR%",
    value: "tsr-percentage",
    show: true,
  },
];

export default RankingColumns;
